import { useEffect } from 'react';
import { DEFAULT_BRAND_LOGO } from '../config/api';
import { fetchBrandImageUrl, updateDocumentFavicon } from '../services/brandingService';

export default function useFavicon() {
  useEffect(() => {
    const loadFavicon = async () => {
      try {
        const faviconUrl = await fetchBrandImageUrl('favicon');
        updateDocumentFavicon(faviconUrl || DEFAULT_BRAND_LOGO);
      } catch (error) {
        updateDocumentFavicon(DEFAULT_BRAND_LOGO);
      }
    };

    loadFavicon();
  }, []);
}
